module.exports = {"components.errorMessage.message.default":"An unexpected error occurred.","components.errorMessage.reload.buttonLabel":"reload","components.errorMessage.message.contentItem1":"Please","components.errorMessage.message.contentItem2":"the page"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/components/ErrorMessage.json
// module id = 721
// module chunks = 0